<template>
    <div class="animated fadeIn order-details">
        <b-card header="Order Details">
            <div class="order-details-body">
                <div class="ordered-items">
                    <div class="ordered-table-wrapper">
                        <table class="summary-table">
                            <thead>
                                <tr>
                                    <th>Pos</th>
                                    <th>Carrier</th>
                                    <th>Type</th>
                                    <th>Item</th>
                                    <th>Quantity</th>
                                    <th>Price</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,i) in orderData.orderItems" v-if="item.volume > 0" class="cost-row">
                                    <td>{{i+1}}</td>
                                    <td>
                                        <div v-if="item.carrier.carrierId != 1" class="carrier-logo-box">
                                            <img :src="item.lightCarrierImage" :alt="'light logo'" class="carrier-logo light-mode">
                                            <img :src="item.darkCarrierImage" :alt="'dark logo'" class="carrier-logo dark-mode">
                                        </div>
                                        <div v-else class="carrier-logo-box">
                                            <img src="./../../assets/img/simon-carrier.svg" alt="" class="carrier-logo light-mode">
                                            <img src="./../../assets/img/simon-carrier-dark.svg" alt="" class="carrier-logo dark-mode">
                                        </div>
                                    </td>
                                    <td v-if="item.carrier.carrierId == 1">
                                        <span class="type flex" v-if="item.id == 4">FLEX</span>
                                        <span class="type nb-iot" v-else-if="item.id == 5">NB-IOT</span>
                                        <span class="type cat-m1" v-else-if="item.id == 6">CAT-M1</span>
                                        <span v-else>N/A</span>
                                    </td>
                                    <td v-else>-</td>
                                    <td>Blank SIM cards</td>
                                    <td>{{item.volume}}</td>
                                    <td>{{item.unitPrice.toFixed(2)}}</td>
                                    <td>{{item.summaryPrice}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="temp-class">
                        <div class="left-side">
                            <div class="order-details-client">
                                <h3 class="client-header">Billing address</h3>
                                <div class="client-data">
                                    <p><strong>{{company.companyName}}</strong></p>
                                    <p>{{orderAddres.address1}},</p>
                                    <p v-if="orderAddres.address2">{{orderAddres.address2}},</p>
                                    <p>{{orderAddres.city}},</p>
                                    <p>{{orderAddres.state}} {{orderAddres.postalCode}}, {{orderAddres.country}}</p>
                                </div>
                            </div>
                            <div class="order-details-client">
                                <h3 class="client-header">Ship to:</h3>
                                <div class="order-ship-address">
                                    <p>{{shippingAddress.addressLine1}},</p>
                                    <p v-if="shippingAddress.addressLine2">{{shippingAddress.addressLine2}},</p>
                                    <p>{{shippingAddress.city}},</p>
                                    <p>{{shippingAddress.state}} {{shippingAddress.postalCode}}, {{shippingAddress.country}}</p>
                                </div>
                            </div>
                            <div v-if="orderData.postPaid == false" class="order-details-client">
                                <h3 class="client-header">Payment Method</h3>
                                <div class="credit-card">
                                    <img class="credit-card-image" :src="require('../../assets/img/' + paymentMethod.cardImg)" alt="credit-card-logo" />
                                    <span class="credit-card-number">... {{paymentMethod.cardNumber}} </span>
                                </div>
                            </div>
                        </div>
                        <div class="right-side">
                            <h4 v-if="taxInclude">Tax</h4>
                            <div v-if="taxInclude" class="order-tax">
                                <span>NYS Sales Tax</span>
                                <span>$ {{unitsTax}}</span>
                            </div>
                            <h4>Shipment</h4>
                            <div class="order-shipment">
                                <span>{{shipping.name}}</span>
                                <span>$ {{shipping.price}}</span>
                            </div>
                            <div class="order-total">
                                <div class="order-total-header">
                                    <h4>Total cost</h4>
                                    <span v-if="taxInclude">Total cost summary with tax and shipping</span>
                                    <span v-else>Total cost summary with shipping</span>
                                </div>
                                <h3 id="finalPrice" v-if="couponData == null || !couponValidation">$ {{finallPrice}}</h3>
                                <div v-if="couponData != null && couponValidation" class="new-price">
                                    <h5 id="finalPriceWithoutCoupon">$ {{finallPrice}}</h5>
                                    <h3 id="finalPriceWithCoupon" v-if="finallPriceWithCupon > 0">$ {{finallPriceWithCupon}}</h3>
                                    <h3 v-else>$0.00</h3>
                                </div>
                            </div>
                            <div :class="['coupon-box', 'no-border']">
                                <h4>Have a promotional code?</h4>
                                <div class="code-input-box">
                                    <input class="coupon-input" placeholder="Enter coupon code" type="text" v-model="couponCode"/>
                                    <button @click="validateCouponCode()" class="apply-coupon">Apply</button>
                                </div>
                            </div>
                            <div v-if="couponValidation === true" class="coupon-code-valid">
                                <i class="fa fa-check"></i>
                                <h5>Promotional code active</h5>
                            </div>
                            <div v-if="couponValidation === false" class="coupon-code-invalid">
                                <i class="fa fa-close"></i>
                                <h5>Promotional code you entered is invalid. Please try again.</h5>
                            </div>
                        </div>
                        <div class="order-processing" v-if="orderProcessing">
                            <div class="order-processing-inner">
                                <div class="sk-wave">
                                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                                </div>

                                <div class="text">
                                    Order processing...
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="control-bar">
                <button class="btn btn-light" id="backOrderButton" v-on:click="backToOrder">Back</button>
                <button class="btn btn-primary action-element" id="placeOrderButton" :disabled="(orderProcessing == true) ? 'disabled' : false" v-on:click="goToConfirm">Place Order</button>
            </div>
        </b-card>
    </div>
</template>

<script>
    import Vue from 'vue'
    import globalStore from '../../variables';
    import Axios from 'axios'
    import VueCookies from 'vue-cookies';
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    export default {
        name: "OrderDetails",
        data() {
            return {
                unitsTax: 0,
                company: {},
                shipping: {
                    name: '',
                    price: 0
                },
                shippingAddress: {},
                paymentMethod: {
                    cardImg: 'MasterCard-icon.svg'
                },
                orderAddres: {
                    address1: '',
                    address2: '',
                    country: '',
                    city: '',
                    postalCode: '',
                    state: '',
                    phoneNumber: ''
                },
                typeAccount: this.$cookies.get('typeAccount'),
                orderProcessing: false,
                totalCost: 0,
                couponCode: '',
                couponData: null,
                couponValidation: null,
                finallPrice: 0,
                finallPriceWithCupon: 0,
                orderData: '',
                priceShipping: '',
                taxInclude: true
            }
        },
        methods: {
            mathFinalPrice() {
                this.finallPrice = Number(this.totalCost) + Number(this.shipping.price) + Number(this.unitsTax);
                this.finallPrice = this.finallPrice.toFixed(2)
                if (this.couponData) {
                    let discount = this.couponData.discountValue;

                    if (this.couponData.discountType == 'Percentage') {
                        discount = parseFloat(discount.replace('%', ''));
                        discount = discount / 100;
                        this.finallPriceWithCupon = (Number(this.totalCost) + Number(this.shipping.price) + Number(this.unitsTax)) * (1 - Number(discount));
                    } else if (this.couponData.discountType == 'Dollar') {
                        discount = parseFloat(discount.replace('$', ''));
                        this.finallPriceWithCupon = Number(this.totalCost) + Number(this.shipping.price) + Number(this.unitsTax) - Number(discount);
                    }


                    this.finallPriceWithCupon = this.finallPriceWithCupon.toFixed(2)
                }
            },
            goToConfirm() {
                this.orderProcessing = true;
                let itemsQuantity = [];

                for (let item of this.orderData.orderItems) {
                    if (item.volume > 0) {
                        itemsQuantity.push({
                            itemId: item.id,
                            itemQuantity: item.volume
                        })
                    }
                }

                 let parsedData = {
                     shippingOptionId: this.orderData.shippingOptionId,
                     shippingAddressId: this.orderData.shippingAddressId,
                     creditCardId: this.orderData.creditCardId,
                     orderItems: itemsQuantity
                 };

                if (this.couponValidation === true) {
                    parsedData.couponCode = this.couponData.code
                }

                Axios.put(globalStore.data.restApiUrl + '/orders', parsedData)
                    .then(response => {
                        this.orderProcessing = false;
                        this.$session.remove('orderData')
                        this.$session.remove('itemsList')
                        this.$session.remove('priceShipping')
                        this.$router.push({name: 'OrderHistory', params: { orderId: response.data}});
                    }).catch(error => {
                        this.orderProcessing = false;

                        if (error.response.data.errors[0].errorCode == 'ResourceThresholdReachedExeption') {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: error.response.data.errors[0].errorMessage,
                                text: error.response.data.errors[0].details,
                                duration: 5000
                            })
                        }

                        if (error.response.status != 429) {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Unable to submit order',
                                text: 'Unable to process the order - Please contact support',
                                duration: 5000,
                            });
                        }
                    })
            },
            backToOrder() {
                this.$router.push('/order/sims');
            },
            getUnitPrice() {
                var tempThis = this
                Axios.get(globalStore.data.restApiUrl + '/orders/unit-price')
                    .then(response => {
                        this.price.pricePerOneSim = response.data.toFixed(2)
                        this.getTaxValue()
                    }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Something went wrong',
                            text: 'Error Retrieving Price Details - Contact Support',
                            duration: 5000,
                        });
                        console.log(error);
                    })
            },
            getTaxValue() {
                let simon = this.orderData.orderItems.filter(item => {
                    return item.carrier.carrierName == 'SimonIoT';
                })
                if (simon[0].volume > 0) {
                    Axios.get(globalStore.data.restApiUrl + '/orders/tax-rate?shippingAddressId=' + this.orderData.shippingAddressId)
                        .then(response => {
                            if (response.data != 0) {
                                this.taxInclude = true;
                                Axios.get(globalStore.data.restApiUrl + '/orders/tax-value/' + simon[0].volume + '?itemId=' + simon[0].id + '&shippingAddressId=' + this.orderData.shippingAddressId)
                                    .then(response => {
                                        this.unitsTax = response.data;
                                        this.unitsTax = this.unitsTax.toFixed(2);
                                        this.countFinalPrize()
                                    }).catch(error => {
                                    this.$notify({
                                        type: 'warn',
                                        group: 'notification',
                                        title: 'Something went wrong',
                                        text: 'Error Retrieving Tax Details - Contact Support',
                                        duration: 5000,
                                    });
                                    console.log(error);
                                })
                            } else {
                                this.countFinalPrize()
                                this.taxInclude = false;
                            }
                        })
                        .catch(error => {
                            this.$notify({
                                type: 'error',
                                group: 'notification',
                                title: 'Counting Tax Error',
                                text: 'An error has occured during counting tax amount, please contact support',
                                duration: 5000,
                            });
                            console.log(error)
                        })
                } else {
                    this.countFinalPrize()
                    this.unitsTax = null;
                }
            },
            countTotalCost() {
                for (let item of this.orderData.orderItems) {
                    this.totalCost = this.totalCost + item.volume * item.unitPrice;
                }
                this.totalCost = Number(this.totalCost) + Number(this.shipping.price) + Number(this.unitsTax);
            },
            userData() {
                Axios.get(globalStore.data.restApiUrl + "/account").then(response => {
                    this.company = response.data;
                    this.orderAddres = this.company.address;
                });
            },
            getShipment(id) {
                var tempThis = this;
                Axios.get(globalStore.data.restApiUrl + "/shipping/options").then(response => {
                    response.data.map(item => {
                        if (item.id == id) {
                            tempThis.shipping.name = item.displayName;
                            tempThis.shipping.price = item.price;
                            tempThis.shipping.price = tempThis.shipping.price.toFixed(2)
                        }
                    })
                });
            },
            getAddress(id) {
                var tempThis = this;
                Axios.get(globalStore.data.restApiUrl + "/shipping/all-addresses").then(response => {
                    response.data.map(item => {
                        if (item.id == id) {
                            tempThis.shippingAddress = item;
                        }
                    })
                });
            },
            getPayment(cardId) {
                var tempThis = this;
                Axios.get(globalStore.data.restApiUrl + "/account/credit-card").then(response => {
                    response.data.forEach(item => {
                        if (item.creditCardId === cardId) {
                            tempThis.paymentMethod = item.card_desc;
                            let cardImg = item.card_desc.substring(0, item.card_desc.indexOf('*'));
                            let cardNum = item.card_desc.substring(item.card_desc.indexOf('*') +5 , item.card_desc.length);
                            if (cardImg == 'Visa') {
                                cardImg = 'Visa-icon.svg'
                            } else if (cardImg == 'MasterCard') {
                                cardImg = 'MasterCard-icon.svg'
                            } else if (cardImg == 'Discover') {
                                cardImg = 'Discover-icon.svg'
                            } else if (cardImg == 'JCB') {
                                cardImg = 'JCB-icon.svg'
                            } else if (cardImg == 'American Express') {
                                cardImg = 'American Express-icon.svg'
                            } else if (cardImg == 'Diners Club') {
                                cardImg = 'dinersclub-icon.svg'
                            } else if (cardImg == 'UnionPay') {
                                cardImg = 'unionpay-icon.svg'
                            } else {
                                cardImg = 'defaultCard-icon.svg'
                            }

                            tempThis.paymentMethod = {
                                creditCardId: item.creditCardId,
                                cardImg: cardImg,
                                cardNumber: cardNum,
                                exp_date: item.exp_date,
                                defcard: item.defcard
                            }
                        }
                    })
                });
            },
            validateCouponCode() {
                Axios.get( globalStore.data.restApiUrl + '/coupon-codes/validate?code=' + this.couponCode)
                .then(response => {
                    this.couponData = response.data;
                    this.couponValidation = true;
                    this.countFinalPrize()
                })
                .catch(error => {
                    this.couponValidation = false;
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Coupon error',
                        text: 'An error has occured during checking coupon code, please contact support',
                        duration: 5000,
                    });
                    console.log(error)
                })
            },
            countFinalPrize() {
                let parsedData = {
                    orderItems: [],
                    shippingOptionId: this.orderData.shippingOptionId,
                    shippingAddressId: this.orderData.shippingAddressId
                }

                for (let item of this.orderData.orderItems) {
                    let itemTemplate = {
                        itemId: item.id,
                        itemQuantity: item.volume
                    }
                    parsedData.orderItems.push(itemTemplate)
                }
                if (this.couponData) {
                    parsedData.couponCode = this.couponCode
                }
                Axios.post(globalStore.data.restApiUrl + '/orders/price-summary', parsedData)
                    .then(response => {
                        if (response.data.couponDiscount) {
                            this.finallPrice = (response.data.totalCost).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})
                            this.finallPriceWithCupon = (response.data.totalCostWithCoupon).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})
                        } else {
                            this.finallPrice = (response.data.totalCost).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})
                        }
                        this.unitsTax = (response.data.taxCharge).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})
                        this.shipping.price = (response.data.shipmentCharge).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})

                        for (let respItem of response.data.orderItems) {
                            for (let localItem of this.orderData.orderItems) {
                                if (respItem.itemId == localItem.id) {
                                    localItem.summaryPrice = (respItem.totalPrice).toLocaleString('en-US', {minimumFractionDigits: 2,maximumFractionDigits: 2})
                                }
                            }
                        }
                    })
            }
        },
        created() {
            this.orderData = this.$session.get('orderData')
            this.priceShipping = this.$session.get('priceShipping');

            for (let item of this.orderData.orderItems) {
                item.summaryPrice = 0
            }

            this.getTaxValue();
            this.userData();
            this.getAddress(this.orderData.shippingAddressId);
            this.getShipment(this.orderData.shippingOptionId);
            this.getPayment(this.orderData.creditCardId);
        }
    }
</script>
<style src="spinkit/scss/spinkit.scss" lang="scss"></style>
<style lang="scss" scoped>

    .order-details-body {
        display: flex;
        .client-header {
            font-size: 15px;
            font-weight: 700;
        }
        .client-name {
            font-size: 14px;
            font-weight: 700;
        }
        .client-contact-header,
        .client-contact-number,
        .client-data {
            font-size: 14px;
            margin:0;
            line-height: 24px;

            p {
                margin-bottom: 0;
            }
        }
        .client-contact-header {
            margin-top: 18px;
        }

        .ordered-items {

            .temp-class {
                display: flex;
                flex-wrap: nowrap;
                padding: 20px 0;
                border-top: 1px solid #dfe2e5;
                .left-side {
                    width: 30%;
                    margin-right: 100px;
                    .order-details-client {
                        padding: 20px;
                        margin-bottom: 20px;
                        border: 1px solid #C9CFD4;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;

                        .order-ship-address {
                            p {
                                margin: 0;
                            }
                        }

                        .credit-card {
                            display: flex;
                            align-items: center;
                            padding: 4px 20px 4px 4px;

                            .credit-card-image {
                                margin-right: 11px;
                            }

                            .credit-card-number {
                                margin-right: 20px;
                            }

                            .credit-card-default {
                                flex-grow: 1;
                                text-align: right;
                            }
                        }
                    }
                }
                .right-side {
                    flex-grow: 1;
                    h4 {
                        margin-top: 18px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    div {
                        display: flex;
                        justify-content: space-between;
                        padding-bottom: 20px;
                        border-bottom: 1px solid #dfe2e5;
                    }

                    .order-total {
                        justify-content: space-between;
                        align-items: center;
                        padding: 0;
                        .order-total-header {
                            display: flex;
                            flex-direction: column;
                            border-bottom: 0;
                            padding: 20px 0;
                            h4 {
                                margin: 0 0 8px;
                            }
                        }

                        h3 {
                            margin-bottom: 0;
                        }

                        .new-price {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-end;
                            padding-bottom: 0;
                            border-bottom: 0;
                            h5 {
                                font-size: 16px;
                                text-decoration: line-through;
                            }
                            h3 {
                                color: #55cd6c;
                            }
                        }
                    }
                    .coupon-box {
                        display: flex;
                        align-items: center;
                        padding: 20px 0;

                        h4 {
                            font-size: 14px;
                            margin: 0;
                        }

                        .code-input-box {
                            display: flex;
                            align-items: center;
                            border: 0;
                            padding-bottom: 0;
                            .coupon-input {
                                border: 1px solid #dfe2e5;
                                border-top-left-radius: 5px;
                                border-bottom-left-radius: 5px;
                                padding: 9px 0 9px 12px;
                                &:focus {
                                    outline: none;
                                }
                            }
                            .apply-coupon {
                                display: block;
                                color: #ffffff;
                                padding: 9px 20px;
                                background-color: #55cd6c;
                                border-top-right-radius: 5px;
                                border-bottom-right-radius: 5px;
                                border: none;
                            }
                        }
                        &.no-border {
                            padding-bottom: 0;
                            border-bottom: none;
                        }
                    }
                    .coupon-code-valid,
                    .coupon-code-invalid {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        padding-top: 20px;
                        padding-bottom: 0;
                        border-bottom: none;
                        i {
                            font-size: 20px;
                            margin-right: 10px;
                        }
                        h5 {
                            margin-bottom: 0;
                        }
                    }

                    .coupon-code-valid {
                        color: #55cd6c;
                    }
                    .coupon-code-invalid {
                        color: #fc4d4d;
                    }
                }
            }



        }
    }

    .summary-table {
        width: 100%;
        table-layout: fixed;
        text-align: left;

        th {
            padding-bottom: 10px;
        }

        th {
            white-space: nowrap;

            &:nth-child(1) {
                width: 14%;
            }

            &:nth-child(2) {
                width: 16%;
            }

            &:nth-child(3) {
                width: 14%;
            }

            &:nth-child(4) {
                width: 14%;
            }

            &:nth-child(5) {
                width: 14%;
            }

            &:nth-child(6) {
                width: 14%;
            }

            &:nth-child(7) {
                width: 14%;
                text-align: right;
            }
        }


        tbody {
            border-top: 1px solid #dfe2e5;

            tr {
                &:nth-child(even) {
                    background-color: #f0f3f5;
                }

                td {
                    padding: 16px 0;

                    &:first-child {
                        padding-left: 10px;
                    }
                    &:last-child {
                        padding-right: 10px;
                    }

                    .type {
                        padding: 4px 8px;
                        -webkit-border-radius: 5px;
                        -moz-border-radius: 5px;
                        border-radius: 5px;
                        color: #3a4149;
                        font-weight: 700;

                        &.flex {
                            background-color: #abe390;
                        }

                        &.nb-iot {
                            background-color: #8ac8ff;
                        }

                        &.cat-m1 {
                            background-color: #ffc400;
                        }
                    }
                    .carrier-logo-box {
                        padding-right: 10px;
                        .carrier-logo {
                            height: 24px;
                            width: auto;
                            max-width: 100%;

                            &.light-mode {
                                display: block;
                            }

                            &.dark-mode {
                                display: none;
                            }
                        }
                    }
                }
            }

            .cost-row {
                td {
                    &:nth-child(7) {
                        text-align: right;
                    }
                    &:nth-child(6)::before,
                    &:nth-child(7)::before {
                        content: '$ ';
                    }
                }
            }

            .total-row {
                font-weight: 700;
                border: none;
                border-top: 2px solid;
                td {
                    font-weight: 400;
                    &:nth-child(4)::before {
                        content: '$ ';
                    }
                }
            }
        }
    }

    .summary-title {
        font-size: 16px;
    }
    .summary-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        h3 {
            font-size: 1em;
            display: inline-block;
        }
    }

    .summary-line {
        display: flex;
        justify-content: space-between;
        width: 100%;
        border-top: 1px solid #dfe2e5;
        padding-top: 10px;

        .summary-money {
            &:before {
                content: '$ ';
            }
        }

        &:first-child {
            border-top: 0;
        }
        &:last-child {
            border-top: 2px solid #073553;
        }
    }

    .control-bar {
        display: flex;
        justify-content: flex-end;

        .btn {
            padding: 8px 20px;
            margin-left: 10px;
        }
    }

    .dark-theme {

        .order-details-body {
            .ordered-items {
                .summary-table {
                    tbody {
                        border-color: #1a1c1d;
                        tr {
                            &:nth-child(even) {
                                background-color: #383e45;
                            }
                            td {
                                .carrier-logo {
                                    &.light-mode {
                                        display: none;
                                    }
                                    &.dark-mode {
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                }

                .temp-class {
                    border-color: #1a1c1d;

                    .left-side {
                        .order-details-client {
                            border-color: #1a1c1d;
                        }
                    }

                    .right-side {
                        .order-tax,
                        .order-shipment,
                        .order-total,
                        .coupon-box {
                            border-color: #1a1c1d;
                            .code-input-box {
                                .coupon-input {
                                    background-color: #515b65;
                                    border-color: #1a1c1d;
                                    color: #fff;
                                    &::placeholder {
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .control-bar {
            border-color: #1a1c1d;
        }
    }

.order-processing {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: rgba(255, 255, 255, 0.7);

    .sk-wave {
        margin: 194px auto 20px;
        height: 60px;
        .sk-rect {
            width: 3px;
            background-color: #39c354;
            border-radius: 4px;
        }
    }

    .text {
        text-align: center;
        font-size: 15px;
        font-weight: 700;
    }
}

.dark-theme {
    .order-processing {
        background-color: rgba(47,53,58, 0.7);
        .order-processing-inner {
            .text {
                color: white;
            }
        }
    }
}
</style>
